module.exports = {
  NOTIFICATION_LIST_REQUEST: "NOTIFICATION_LIST_REQUEST",
  NOTIFICATION_LIST_SUCCESS: "NOTIFICATION_LIST_SUCCESS",
  NOTIFICATION_LIST_FAIL: "NOTIFICATION_LIST_FAIL",

  NOTIFICATION_MARK_AS_READ: "NOTIFICATION_MARK_AS_READ",
  NOTIFICATION_MARK_ALL_AS_READ: "NOTIFICATION_MARK_ALL_AS_READ",
};
